import React from "react"
import { css } from "@jsUtils"

import Styles from "./circle.module.scss"

/**
 * Circle with symbol for CTAs and buttons
 * @param {object} props - react props
 * @param {string} props.theme - background color theme (light/dark)
 * @param {COLORS.BLUE|COLORS.FLURO|COLORS.WORKS} props.color - circle color. . If specified, affects all states.
 * @param {'small'|undefined} props.size - circle size. If undefined, default size.
 * @param {boolean} props.filled - filled styling
 * @param {boolean} props.whiteOutlinedHover - whiteOutlinedHover styling, with color fill on hover
 * @param {boolean} props.flipped - horizontally flipped
 * @param {'chevron'|'plusMinus'|'play'|'pause'|undefined} props.content - symbol name. Symbols are generated internally by CSS.
 * @param {string} props.className - class name
 * @param {boolean} inverseSymbol - show the inverse of the default symbol (props.content). Only defined for 'plus': inverseSymbol=true will show the 'minus' symbol.
 */
const Circle = props => {
  const {
    theme,
    color,
    filled,
    flipped,
    inverseSymbol,
    whiteOutlinedHover,
    size,
    content,
    className
  } = props
  return (
    <div
      className={css(
        Styles.circle,
        theme && Styles[`theme_${theme}`],
        color && Styles[color],
        size && Styles[size],
        content && Styles[content],
        flipped && Styles.flipped,
        whiteOutlinedHover && Styles.whiteOutlinedHover,
        filled && Styles.filled,
        inverseSymbol && Styles.inverseSymbol,
        className
      )}
    >
      <div className={Styles.symbolExtra} />
    </div>
  )
}

export default Circle
